import { RouteDefinitions } from '@common/route-definitions';
import { Roles, Role } from '@models/Roles';
import { Route } from './side-drawer.component';

const SideDrawerRoutes: Array<Route> = [
  {
    name: 'Sales',
    friendlyName: 'Sales',
    path: '',
    isActive: false,
    allowedRoles: [Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting(), ...Role.GetAllService()],
    children: [
      {
        name: 'Dashboard',
        friendlyName: 'Dashboard',
        path: RouteDefinitions.dashboard,
        isActive: false,
        allowedRoles: [...Role.GetAll()],
        children: []
      },
      {
        name: 'Online To-Do',
        friendlyName: 'To-Do',
        path: RouteDefinitions.onlineToDo,
        isActive: false,
        allowedRoles: [...Role.GetAll()],
        children: []
      },
      {
        name: 'Profile',
        friendlyName: '',
        path: '',
        isActive: false,
        allowedRoles: [Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting(), ...Role.GetAllService()],
        children: [
          {
            name: 'Customer',
            friendlyName: 'Customer',
            path: RouteDefinitions.customer.Search,
            isActive: false,
            allowedRoles: [Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting(), ...Role.GetAllService()],
            children: []
          },
          {
            name: 'RE Agent',
            friendlyName: 'Real Estate Agents',
            path: RouteDefinitions.realestateagent.Search,
            isActive: false,
            allowedRoles: [Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting(), ...Role.GetAllService()],
            children: []
          },
          {
            name: 'RE Office',
            friendlyName: 'Real Estate Offices',
            path: RouteDefinitions.realestateoffice.Search,
            isActive: false,
            allowedRoles: [Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting(), ...Role.GetAllService()],
            children: []
          },
          {
            name: 'Escrow Officer',
            friendlyName: 'Escrow Officers',
            path: RouteDefinitions.escrowofficer.Search,
            isActive: false,
            allowedRoles: [Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting(), ...Role.GetAllService()],
            children: []
          },
          {
            name: 'Escrow Office',
            friendlyName: 'Escrow Offices',
            path: RouteDefinitions.escrowoffice.Search,
            isActive: false,
            allowedRoles: [Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting(), ...Role.GetAllService()],
            children: []
          },
          {
            name: 'Trans Coordinator',
            friendlyName: 'Trans Coordinators',
            path: RouteDefinitions.transactioncoordinator.Search,
            isActive: false,
            allowedRoles: [Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting(), ...Role.GetAllService()],
            children: []
          },
          {
            name: 'Property Manager',
            friendlyName: 'Property Managers',
            path: RouteDefinitions.propertymanager.Search,
            isActive: false,
            allowedRoles: [Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting(), ...Role.GetAllService()],
            children: []
          },
          {
            name: 'P. Mgmt. Office',
            friendlyName: 'P. Managment Office',
            path: RouteDefinitions.propertymanagementoffice.Search,
            isActive: false,
            allowedRoles: [Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting(), ...Role.GetAllService()],
            children: []
          }
          // {
          //   name: 'Vendor',
          //   friendlyName: 'Vendor',
          //   path: RouteDefinitions.vendor.Create, // change to search once search page is made
          //   isActive: false,
          //   allowedRoles: [Roles.Admin],
          //   children: []
          // }

          // {
          //     name: 'SAM Territory',
          //     path: '/samterritory-search',
          //     isActive: false,
          //     children: []
          // }
        ]
      },
      {
        name: 'Quote',
        friendlyName: 'Quotes',
        path: RouteDefinitions.quote.Search,
        isActive: false,
        allowedRoles: [Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting(), ...Role.GetAllService()],
        children: []
      },
      {
        name: 'Create Order',
        friendlyName: 'Create Order',
        path: RouteDefinitions.contract.Create,
        isActive: false,
        allowedRoles: [Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting()],
        children: []
      },
      {
        name: 'Search Orders',
        friendlyName: 'Search Orders',
        path: RouteDefinitions.contract.Search,
        isActive: false,
        allowedRoles: [Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting()],
        children: []
      }
    ]
  },
  {
    name: 'Claims',
    friendlyName: 'Claims',
    path: '/service',
    isActive: false,
    allowedRoles: [Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting(), ...Role.GetAllService()],
    children: [
      {
        name: 'Swo Search',
        friendlyName: 'Search',
        path: RouteDefinitions.serviceworkorder.Search,
        isActive: false,
        allowedRoles: [Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting(), ...Role.GetAllService()],
        children: []
      },
      {
        name: 'Dispatch',
        friendlyName: 'Dispatch',
        path: RouteDefinitions.dispatch.Landing,
        isActive: false,
        allowedRoles: [Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting(), ...Role.GetAllService()],
        children: []
      },
      {
        name: 'Authorization',
        friendlyName: 'Authorization',
        path: RouteDefinitions.authorization.Search,
        isActive: false,
        allowedRoles: [Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting(), ...Role.GetAllService()],
        children: []
      },
      {
        name: 'Purchasing',
        friendlyName: 'Purchasing',
        path: RouteDefinitions.purchasing.Search,
        isActive: false,
        allowedRoles: [Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting(), ...Role.GetAllService()],
        children: []
      },
      {
        name: 'CIL',
        friendlyName: 'CIL',
        path: RouteDefinitions.cil.Search,
        isActive: false,
        allowedRoles: [Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting(), ...Role.GetAllService()],
        children: []
      }
    ]
  },
  {
    name: 'Accounting',
    friendlyName: 'Accounting',
    path: '',
    isActive: false,
    allowedRoles: [Roles.Admin, ...Role.GetAllAccounting()],
    children: [
      // {
      //   name: 'Accounting',
      //   friendlyName: 'Accounting',
      //   path: RouteDefinitions.accounting.List,
      //   isActive: false,
      //   allowedRoles: [Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting(), ...Role.GetAllService()],
      //   children: []
      // },
      {
        name: 'Invoicing',
        friendlyName: 'Invoicing',
        path: RouteDefinitions.invoicing.Search,
        isActive: false,
        allowedRoles: [Roles.Admin, ...Role.GetAllAccounting()],
        children: []
      }
    ]
  },
  {
    name: 'Vendors',
    friendlyName: 'Vendors',
    path: '',
    isActive: false,
    allowedRoles: [Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting(), ...Role.GetAllService()],
    children: [
      {
        name: 'Vendor Dashboard',
        friendlyName: 'Vendor Dashboard',
        path: RouteDefinitions.vendor.Search,
        isActive: false,
        allowedRoles: [Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting(), ...Role.GetAllService()],
        children: []
      }
      // {
      //   name: 'Price Agreements',
      //   friendlyName: 'Price Agreements',
      //   path: RouteDefinitions.vendor.PriceAgreements,
      //   isActive: false,
      //   allowedRoles: [Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting(), ...Role.GetAllService()],
      //   children: []
      // },
      // {
      //   name: 'VQAs',
      //   friendlyName: 'VQAs',
      //   path: RouteDefinitions.vendor.VQAs,
      //   isActive: false,
      //   allowedRoles: [Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting(), ...Role.GetAllService()],
      //   children: []
      // },
      // {
      //   name: 'Vendor Rerating',
      //   friendlyName: 'Vendor Rerating',
      //   path: RouteDefinitions.vendor.Rerating,
      //   isActive: false,
      //   allowedRoles: [Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting(), ...Role.GetAllService()],
      //   children: []
      // },
      // {
      //   name: 'Vendor Groups',
      //   friendlyName: 'Vendor Groups',
      //   path: RouteDefinitions.vendor.Groups,
      //   isActive: false,
      //   allowedRoles: [Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting(), ...Role.GetAllService()],
      //   children: []
      // }
    ]
  }
];

export default SideDrawerRoutes;



// WEBPACK FOOTER //
// ./src/side-drawer/sidedrawer-routes.ts